import Lab from './Lab'
export default Lab
